
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartBoundaryIec as ObiChartBoundaryIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-boundary-iec.js';
 
 
 

 
 export const ObiChartBoundaryIec = createComponent({
   react: React,
   tagName: 'obi-chart-boundary-iec',
   elementClass: ObiChartBoundaryIecElement,
   events: {
     
   }
  });
 
 